/** @jsx jsx */
import { Checkbox, jsx, Label, Radio, Flex, Box, Grid } from "theme-ui";
import React, { useState, useEffect } from "react";
import { DynamicField } from "sites-common/components/DynamicField";
import PropTypes from "prop-types";

const initialTreeValue = [];
const packageType = {
  customQty: "custom",
  predefinedQty: "predefined",
};

const PackageComp = (props) => {
  const { projects, type, onHandleTreeFieldChange } = props;
  const packageOptions = {
    predefinedPackage: {
      label: "Select Package",
      rate: projects.rate || 0,
      data: [],
      containerStyle: {},
      defaultValue: "",
      ...projects.predefinedPackage,
    },
    customPackage: {
      inputLabel: "Quantity",
      rate: projects.rate || 0,
      extraLabel: "",
      extra: [],
      ...projects.customPackage,
    },
  };

  const { predefinedPackage, customPackage } = packageOptions;
  const [quantity, setQuantity] = useState("");
  const [selectedPack, setSelectedPack] = useState(
    predefinedPackage.defaultValue || ""
  );
  const [selectedTree, setSelectedTree] = useState([]);
  const [treeCheck, setTreeCheck] = useState([]);
  const [isShowAlert, setShowAlert] = useState(false);

  const predefinedResetState = () => {
    setSelectedPack("");
  };

  const customResetState = () => {
    setSelectedTree(initialTreeValue);
    setShowAlert(false);
    setQuantity("");
  };

  const quantityChangeHandler = (value) => {
    if (!value || (treeCheck && value && treeCheck.length > value)) {
      setTreeCheck(initialTreeValue);
      setShowAlert(false);
    }
    setQuantity(value);
    setSelectedPack("");
  };

  const ScrollInView = () => {
    if (document.getElementById("refID")) {
      document
        .getElementById("refID")
        .scrollIntoView({ top: 0, behavior: "smooth" });
    }
  };

  const checkboxHandler = (item) => {
    if (!quantity) {
      setShowAlert(true);
      return;
    }
    if (!treeCheck.includes(item)) {
      if (treeCheck.length + 1 > quantity) {
        setShowAlert(true);
      } else {
        const updateTree = [...treeCheck, item];
        setTreeCheck(updateTree);
      }
    } else {
      const index = treeCheck.indexOf(item);
      treeCheck.splice(index, 1);
      setShowAlert(false);
      setTreeCheck([...treeCheck]);
    }
    predefinedResetState();
    ScrollInView();
  };

  const treePackageSelectHandler = (item) => {
    customResetState();
    if (item) {
      setSelectedTree(item.desc);
    }
    setSelectedPack(item);
    setTreeCheck([]);
  };

  useEffect(() => {
    if (quantity < treeCheck.length) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  }, [quantity, treeCheck]);

  useEffect(() => {
    (async () => {
      onHandleTreeFieldChange(
        quantity,
        selectedPack,
        selectedTree,
        treeCheck.toString()
      );
    })();
  }, [
    quantity,
    selectedPack,
    treeCheck,
    selectedTree,
    props,
    onHandleTreeFieldChange,
  ]);

  const CustomPackageComponent = () => (
    <div>
      <div
        sx={{
          paddingTop: "10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {" "}
        <h5>{customPackage.inputLabel}</h5>
        <div
          sx={{
            width: [null, "150px", null],
            ml: "3",
            "input::-webkit-inner-spin-button": {
              WebkitAppearance: "none !important",
              margin: "0px !important",
            },
            "input::-webkit-outer-spin-button": {
              WebkitAppearance: "none !important",
              margin: "0px !important",
            },
          }}
        >
          <DynamicField
            sx={{ backgroundColor: "#fff" }}
            value={quantity}
            onChange={(val) => {
              quantityChangeHandler(val);
            }}
            type="number"
            name=""
          />
        </div>
        <p sx={{ width: "200px", margin: "0px", padding: "0px 10px" }}>
          {customPackage.rate > 0 && `X ${customPackage.rate}`}
        </p>
      </div>
      {customPackage.extra.length > 0 && (
        <div>
          <div sx={{ marginTop: "10px" }}>
            <h5>{customPackage.extraLabel}</h5>
            {isShowAlert && (
              <span sx={{ background: "#FBE3E4", color: "#8A1F11" }}>
                Please increase the quantity
              </span>
            )}
          </div>
          <div
            sx={{
              maxHeight: "200px",
              overflowY: "auto",
              border: "1px solid #ccc",
              padding: "10px",
              position: "relative",
            }}
          >
            {customPackage.extra.map((item, idx) => (
              <Label sx={{ variant: "package" }} key={item}>
                <Checkbox
                  onChange={() => checkboxHandler(item)}
                  value={idx}
                  checked={!!treeCheck.includes(item)}
                />
                {item}
              </Label>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  const PredefinedPackageComponent = () => (
    <React.Fragment>
      <h5>{predefinedPackage.label}</h5>
      <Flex
        sx={{
          flexDirection: "column",
          ...predefinedPackage.containerStyle,
        }}
      >
        {predefinedPackage.data.map((item) => (
          <Box key={item.title} sx={{ marginBottom: "10px" }}>
            <div sx={{ marginTop: "20px" }}>
              <Label sx={{ cursor: "pointer" }}>
                <Radio
                  name="package"
                  onClick={() => treePackageSelectHandler(item)}
                  checked={selectedPack.title === item.title}
                />
                <span sx={{ fontSize: "18px" }}>{item.title}</span>
              </Label>
            </div>
            <span sx={{ fontSize: "14px" }}>{item.desc}</span>
          </Box>
        ))}
      </Flex>
    </React.Fragment>
  );

  const renderPackageComp = (PType) => {
    let component = "";
    switch (PType) {
      case packageType.customQty:
        component = <Box>{CustomPackageComponent()}</Box>;
        break;
      case packageType.predefinedQty:
        component = <Box>{PredefinedPackageComponent()}</Box>;
        break;
      default:
        component = (
          <React.Fragment>
            <Grid columns={[1, 1, "6fr 1fr 6fr", null]} gap={3} id="refID">
              <Box>{CustomPackageComponent()}</Box>
              <Box sx={{ textAlign: "center", alignSelf: "center" }}>
                <b>(OR)</b>
              </Box>
              <Box>{PredefinedPackageComponent()}</Box>
            </Grid>
          </React.Fragment>
        );
        break;
    }
    return component;
  };
  if (!projects) {
    return null;
  }
  return <div>{renderPackageComp(type)}</div>;
};

PackageComp.defaultProps = {
  type: "",
  projects: {},
};

PackageComp.propTypes = {
  projects: PropTypes.objectOf(PropTypes.any),
  type: PropTypes.string,
  onHandleTreeFieldChange: PropTypes.func.isRequired,
};

export default PackageComp;
